import * as React from 'react';

const TFLogoSVG = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      id="prefix__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 121.5 121.5"
      xmlSpace="preserve"
      {...props}
    >
      <style />
      <path d="M117.1 68.3c.3-2.5.5-5 .5-7.5 0-2.4-.2-4.9-.5-7.4v-.1l-9.7 1.2c-.5-4.2-1.6-8.1-3.2-11.9l9-3.7c-1.9-4.6-4.4-8.9-7.4-12.9l-7.7 5.9c-2.5-3.3-5.4-6.2-8.7-8.7l5.9-7.7c-3.9-3-8.3-5.5-12.8-7.4l-3.7 9c-3.8-1.6-7.7-2.6-11.9-3.2l1.3-9.7c-2.4-.3-4.9-.5-7.4-.5-2.4 0-4.9.2-7.4.5h-.1l1.2 9.7c-4.2.5-8.1 1.6-11.9 3.2l-3.7-9C34.3 10 30 12.5 26 15.5l5.9 7.7c-3.3 2.5-6.2 5.4-8.7 8.7L15.5 26c-3 3.9-5.5 8.2-7.4 12.8l9 3.8c-1.6 3.8-2.6 7.7-3.2 11.9l-9.7-1.3c-.3 2.4-.5 4.9-.5 7.4 0 2.4.2 4.9.5 7.4l9.7-1.2c.5 4.2 1.6 8.1 3.2 11.9l-9 3.7c1.9 4.6 4.4 8.9 7.4 12.9l7.7-5.9c2.5 3.3 5.4 6.2 8.7 8.7l-5.9 7.7c3.9 3 8.2 5.5 12.8 7.4l3.8-9c3.8 1.6 7.7 2.6 11.9 3.2l-1.3 9.7c2.5.3 5 .5 7.4.5 2.4 0 4.9-.2 7.4-.5l-1.3-9.7c4.2-.5 8.1-1.6 11.9-3.2l3.7 9c4.6-1.9 8.9-4.4 12.9-7.4l-5.9-7.7c3.3-2.5 6.2-5.4 8.7-8.7l7.7 6c3-3.9 5.5-8.2 7.4-12.8l-9-3.8c1.6-3.8 2.7-7.7 3.2-11.9l9.8 1.4zM65.5 97.6c-20.3 2.6-39-11.7-41.6-32.1-2.6-20.3 11.7-39 32.1-41.6C76.3 21.3 95 35.6 97.6 56c2.6 20.3-11.7 38.9-32.1 41.6z" />
      <path d="M59.1 39.5H37.4v9.9h18.4v41.2h9.9V71.9H76V62H65.7V49.4h18.4v-9.9H60.9z" />
    </svg>
  );
};

export default TFLogoSVG;
